import TagManager from '@/common/TagManager';

export const state = {
  stateGtmData: []
};

export const actions = {
  register(context, payload) {
    const tagManager = new TagManager(payload);
    const gtmData = tagManager.getGtmObject(payload.event);

    if (gtmData !== undefined) {
      context.commit('PUSH_GTM_DATA', gtmData);
    }
  }
};

export const mutations = {
  RESET_GTM_DATA(state) {
    state.stateGtmData.shift();
  },
  PUSH_GTM_DATA(state, gtmData) {
    state.stateGtmData.push(gtmData);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
